export default {
  forward_link: 'Forward Link',
  forward_image: 'Forward Image',
  forward_file: 'Forward File',
  forward_message: 'Forward Message',
  download: 'Download',
  forward: 'Forward',
};
